import { ExclamationDiamond, X } from "react-bootstrap-icons";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import * as DinamicQueries from "../../api/DinamicsQuery";
import { SelectBox } from "devextreme-react/select-box";
import { TextArea } from "devextreme-react/text-area"; // No eliminar, sin esto no funciona el input textarea aunque no se use la variable
import { NumberBox } from "devextreme-react/number-box";
import ScrollView from "devextreme-react/scroll-view";
import React, { useState, useEffect } from "react";
import { ArrowRight, ArrowLeft } from "react-bootstrap-icons";
import { Button } from "devextreme-react/button";
import { Toast } from "devextreme-react/toast";
import { CheckBox } from "devextreme-react/check-box";
import MapRoutes from "../../components/popup-create-establishment/widgets/MapRoutes";
import "./AssignmentNew.scss";

import DataGrid, {
  Column,
  Pager,
  Paging,
  FilterRow,
  HeaderFilter,
  Scrolling,
  LoadPanel,
  Selection,
  ColumnChooser,
  Export,
  Toolbar,
  Item,
  Editing,
} from "devextreme-react/data-grid";
import { SimpleItem } from "devextreme-react/form";

function AssignmentNew() {
  const [msgPopup, setMsgPopup] = useState("Asignar Establecimiento");
  const [showPopup, setShowPopup] = useState(false);
  const [showPopupRuta, setShowPopupRuta] = useState(false);
  const [User, setUser] = useState([]);
  const [Establecimientos, setEstablecimientos] = useState([]);
  const [Clientes, setClientes] = useState([]);
  const [Regiones, setRegiones] = useState([]);
  const [UserSelected, setUserSelected] = useState([]);
  const [isPromotor, setisPromotor] = useState(true);
  const [UserSelectedData, setUserSelectedData] = useState("");
  const [weekButtons, setWeekButtons] = useState(false);
  const [selectedStablisments, setSelectedStablisments] = useState([]);
  const [DataUsuarioSelected, setDataUsuarioSelected] = useState();
  // const [datagrid, setDataGrid] = useState(null);
  const [disabledRuta, setdisabledRuta] = useState(false);
  const initialState = {
    cliente: "",
    region: "",
    formulario: "",
    establecimientos: [],
    establecimientosFinal: [],
  };
  const [Asignacion, setAsignacion] = useState(initialState);
  const allowedPageSizes = [8, 12, 20];
  const [toastConfig, setToastConfig] = React.useState(
    {
      isVisible: false,
      type: "success",
      message: "Guardado Exitosamente",
      displayTime: 4000,
    },
    []
  );

  const [idsEstablecimientoToAssing, setidsEstablecimientoToAssing] = useState(
    []
  );
  const [SelectedIdEstablecimiento, setSelectedIdEstablecimiento] = useState();
  const [showPopupDelete, setShowPopupDelete] = useState(false);
  const [idsEstablecimientoAsiganed, setidsEstablecimientoAsiganed] = useState(
    []
  );

  // Estado para el modal y las plantillas
  const [showModalPlantillas, setShowModalPlantillas] = useState(false);
  const [plantillasRutas, setPlantillasRutas] = useState([]);
  const [plantillaSeleccionada, setPlantillaSeleccionada] = useState(null);
  const [usuarioParaAsignar, setUsuarioParaAsignar] = useState(null);
  const [establecimientosPlantilla, setEstablecimientosPlantilla] = useState(
    []
  );
  const [establecimientosSeleccionados, setEstablecimientosSeleccionados] =
    useState([]);
  const [usuariosSeleccionados, setUsuariosSeleccionados] = useState([]);

  // Estados para el mapa de rutas
  const [showPopupMapa, setShowPopupMapa] = useState(false);
  const [rutasParaMapa, setRutasParaMapa] = useState([]);

  useEffect(() => {
    getAllUser();
    // get clients
    const userData = JSON.parse(localStorage.getItem("userData"));
    // setClientes(userData.cliente);
    // setRegiones(userData.region);
  }, []);

  const hidePopup = () => {
    setShowPopup(false);
    setAsignacion(initialState);
    setEstablecimientos([]);
    setMsgPopup("Asignar Establecimiento");

    // Procesar rutas para el usuario cuando se cierra el popup
    if (UserSelected) {
      DinamicQueries.getDataWithParameters(
        "processRoutesForUser",
        "usuarios/",
        { uid: UserSelected }
      )
        .then((data) => {
          if (data.status === 200) {
            console.log("Rutas procesadas correctamente");
          }
        })
        .catch((err) => {
          console.error("Error al procesar rutas:", err);
        });
    }
  };

  const hidePopupRuta = () => {
    setShowPopupRuta(false);
    setAsignacion(initialState);
    setEstablecimientos([]);
    setMsgPopup("Asignar Establecimiento");
  };

  const cellRender = (data) => {
    return (
      <div className="d-flex icons_grid">
        <i
          className="dx-icon-import"
          onClick={() => AsignarData(data.data)}
          title="Administrar establecimientos"
        ></i>
        <i
          className="dx-icon-chevronnext"
          onClick={() => MostrarRuta(data.data)}
          title="Mostrar ruta"
        ></i>
        <i
          className="dx-icon-user"
          onClick={() => abrirAsignarRuta(data.data)}
          title="Asignar ruta a usuario"
          style={{ cursor: "pointer", marginLeft: "8px" }}
        ></i>
        {/* <i className="dx-icon-trash" onClick={()=>openDeletePopup(data.data)}></i> */}
      </div>
    );
  };

  function saveEstablishment(e) {
    console.log(idsEstablecimientoToAssing);
    console.log(Establecimientos);

    const dataEstablecimientos = [...Asignacion.establecimientosFinal];
    idsEstablecimientoToAssing.forEach((eachID) => {
      Establecimientos.forEach((usuarioData) => {
        if (usuarioData.ID_FB === eachID) {
          usuarioData.ID =
            usuarioData.ID == undefined || usuarioData.ID == ""
              ? usuarioData.ID_STORE
              : usuarioData.ID;
          dataEstablecimientos.push(usuarioData);
        }
      });
    });
    console.log(dataEstablecimientos);

    let arrayEstablecimiento = [];
    dataEstablecimientos.forEach((eachEstab) => {
      if (arrayEstablecimiento.length > 0) {
        let existe = false;
        arrayEstablecimiento.forEach((x) => {
          if (x.ID === eachEstab.ID) {
            existe = true;
          }
        });
        if (!existe) {
          arrayEstablecimiento.push(eachEstab);
        }
      } else {
        arrayEstablecimiento.push(eachEstab);
      }
    });

    console.log(arrayEstablecimiento);

    let dataFinal = [];
    console.log(arrayEstablecimiento);
    const userData = JSON.parse(localStorage.getItem("userData"));
    arrayEstablecimiento.forEach((x) => {
      let info;
      console.log(isPromotor);
      if (isPromotor) {
        info = {
          ID: x.ID,
          codigo_region:
            x.codigo_region == undefined ? x.ID_REGION_FB : x.codigo_region,
          key: x.key == undefined ? x.ID_FB : x.key,
          nombre_establecimiento:
            x.nombre_establecimiento == undefined
              ? x.NAME
              : x.nombre_establecimiento,
          nombre_region:
            x.nombre_region == undefined ? x.NAME_REGION : x.nombre_region,
          uid_region: x.uid_region == undefined ? x.ID_REGION_FB : x.uid_region,
          dias: x.dias == undefined ? [] : x.dias,
          revisado: x.REVIEWED == undefined ? false : x.REVIEWED,
          modificadoPor: userData.id || userData.uid,
          modificadoFecha: new Date(),
          modificadoPorNombre: userData.nombre || userData.name,
          desde: "Asignar Establecimientos",
        };
      } else {
        info = {
          ID: x.ID,
          key: x.key == undefined ? x.ID_FB : x.key,
          nombre_establecimiento:
            x.nombre_establecimiento == undefined
              ? x.NAME
              : x.nombre_establecimiento,
          nombre_region:
            x.nombre_region == undefined ? x.NAME_REGION : x.nombre_region,
          uid_region: x.uid_region == undefined ? x.ID_REGION_FB : x.uid_region,
          dias: x.dias == undefined ? [] : x.dias,
          revisado: x.REVIEWED == undefined ? false : x.REVIEWED,
          modificadoPor: userData.id || userData.uid,
          modificadoFecha: new Date(),
          modificadoPorNombre: userData.nombre || userData.name,
          desde: "Asignar Establecimientos",
        };
      }
      dataFinal.push(info);
    });

    console.log(dataFinal);
    console.log(arrayEstablecimiento);

    DinamicQueries.getDataWithParameters(
      "AsignarNewCollectionEstablecimientos",
      "usuarios/",
      {
        uid: UserSelected,
        establecimientos: dataFinal,
        ModificadoPor: {
          id: userData.id || "",
          key: userData.key || "",
          uid: userData.uid || "",
          nombre: `${userData.nombre || ""} ${userData.apellido || ""}`.trim(),
          cedula: userData.cedula || "",
        },
      }
    ).then((data) => {
      console.log(data);
      if (data.status == 200) {
        setAsignacion(initialState);
        setidsEstablecimientoToAssing([]);
        // hidePopup();
        AsignarData(DataUsuarioSelected);
        getAllUser();

        setToastConfig({
          ...toastConfig,
          type: "success",
          message: "¡Guardado Exitosamente!",
          isVisible: true,
        });
      } else {
      }
    });
    // .catch((err) => {
    //   setToastConfig({
    //     ...toastConfig,
    //     type: "error",
    //     message: err.message,
    //     isVisible: true,
    //   });
    //   setAsignacion(initialState);
    //   hidePopup();
    // });
  }

  const getAllUser = () => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    DinamicQueries.getDataWithParameters("getaUserNewFormat", "usuarios/", {
      uid: userData.uid,
    })
      .then((usuarios) => {
        console.log(usuarios);
        setUser(usuarios.data);
      })
      .catch((err) => {
        setToastConfig({
          ...toastConfig,
          type: "error",
          message: err.message,
          isVisible: true,
        });
      });
  };

  const AsignarData = (user) => {
    console.log(user);
    console.log(Regiones);
    console.log(user.region[0]);
    setDataUsuarioSelected(user);
    setUserSelectedData(
      user.nombre == undefined ? UserSelectedData : user.nombre
    );
    setUserSelected(user.uid);
    DinamicQueries.getDataWithParameters("getStoreNewFormat", "usuarios/", {
      uid: user.uid,
    }).then((usuario) => {
      console.log(usuario);
      DinamicQueries.getDataWithParameters("callProcedure", "analytics/", {
        method: "sp_get_storeWithRegion",
        params: {
          nameRegion: user.region[0],
        },
      }).then((establecimientos) => {
        DinamicQueries.getDataWithParameters(
          "getEstablecimientoNewCollection",
          "usuarios/",
          {
            uid: user.uid,
          }
        ).then((EstablecimientosAsigandosColeccionNueva) => {
          // console.log(user)
          // console.log(establecimientos)
          console.log(EstablecimientosAsigandosColeccionNueva);
          if (user.perfil == "Promotor") {
            setisPromotor(true);
          } else {
            setisPromotor(false);
          }

          setEstablecimientos(establecimientos.data);

          setAsignacion({
            ...Asignacion,
            establecimientos: usuario.data,
            establecimientosFinal: usuario.data,
            region: user.region[0],
          });

          setClientes(user.cliente[0]);
          console.log(user.region[0]);
          setRegiones(user.region);
        });
      });
    });
    setShowPopup(true);
  };

  // Función auxiliar para obtener datos de ruta de un usuario (sin mostrar popup)
  const obtenerDatosRutaUsuario = async (user) => {
    try {
      const EstablecimientosAsigandosColeccionNueva =
        await DinamicQueries.getDataWithParameters(
          "getEstablecimientoNewCollection",
          "usuarios/",
          { uid: user.uid }
        );

      let EstablecimientosUsuario = [];
      EstablecimientosAsigandosColeccionNueva.data.data.forEach(
        (establecimientosRuta) => {
          if (establecimientosRuta != undefined) {
            EstablecimientosUsuario.push(establecimientosRuta);
          }
        }
      );

      let dataFinal = [];
      EstablecimientosUsuario.forEach((x) => {
        x.lunes = false;
        x.martes = false;
        x.miercoles = false;
        x.jueves = false;
        x.viernes = false;
        x.sabado = false;
        x.domingo = false;
        if (x.dias != undefined) {
          x.dias.forEach((dia) => {
            switch (dia) {
              case 1:
                x.lunes = true;
                break;
              case 2:
                x.martes = true;
                break;
              case 3:
                x.miercoles = true;
                break;
              case 4:
                x.jueves = true;
                break;
              case 5:
                x.viernes = true;
                break;
              case 6:
                x.sabado = true;
                break;
              case 7:
                x.domingo = true;
                break;
              default:
                break;
            }
          });
        }
        dataFinal.push(x);
      });

      return {
        usuario: user,
        establecimientos: dataFinal,
      };
    } catch (error) {
      console.error("Error obteniendo datos de ruta:", error);
      return null;
    }
  };

  const MostrarRuta = (user) => {
    setUserSelected(user.uid);
    DinamicQueries.getDataWithParameters("getaUser", "usuarios/", {
      uid: user.uid,
    }).then((usuario) => {
      DinamicQueries.getDataWithParameters(
        "getEstablecimientoNewCollection",
        "usuarios/",
        {
          uid: user.uid,
        }
      ).then((EstablecimientosAsigandosColeccionNueva) => {
        DinamicQueries.getDataWithParameters(
          "getEstablecimientosNewFilter",
          "galeria/",
          {
            cliente: usuario.data[0].cliente[0],
            region: usuario.data[0].region[0],
          }
        ).then((establecimientos) => {
          // setEstablecimientos(establecimientos.data)
          let EstablecimientosUsuario = [];
          console.log(EstablecimientosAsigandosColeccionNueva.data.data);
          EstablecimientosAsigandosColeccionNueva.data.data.forEach(
            (establecimientosRuta) => {
              if (establecimientosRuta != undefined) {
                // establecimientosRuta.forEach((element) => {
                // element.key = Math.random()
                EstablecimientosUsuario.push(establecimientosRuta);
                // });
              }
            }
          );
          let dataFinal = [];
          EstablecimientosUsuario.forEach((x) => {
            x.lunes = false;
            x.martes = false;
            x.miercoles = false;
            x.jueves = false;
            x.viernes = false;
            x.sabado = false;
            x.domingo = false;
            if (x.dias != undefined) {
              x.dias.forEach((dia) => {
                switch (dia) {
                  case 1:
                    x.lunes = true;
                    break;
                  case 2:
                    x.martes = true;
                    break;
                  case 3:
                    x.miercoles = true;
                    break;
                  case 4:
                    x.jueves = true;
                    break;
                  case 5:
                    x.viernes = true;
                    break;
                  case 6:
                    x.sabado = true;
                    break;
                  case 7:
                    x.domingo = true;
                    break;
                  default:
                    break;
                }
              });
            }
            dataFinal.push(x);
          });
          setAsignacion({
            ...Asignacion,
            establecimientos: dataFinal,
            establecimientosFinal: dataFinal,
          });
          setTimeout(() => {
            setdisabledRuta(false);
          }, 1000);
        });
      });
      setShowPopupRuta(true);
    });
  };

  // Función para abrir el modal y cargar plantillas
  const abrirAsignarRuta = (usuario) => {
    setUsuarioParaAsignar(usuario);
    // Aquí deberías traer las plantillas desde tu API o estado global
    DinamicQueries.getData("getrutasPlanilla", "rutasPlanilla/")
      .then((res) => {
        console.log("plantillas", res.data);
        setPlantillasRutas(res.data);
        setShowModalPlantillas(true);
      })
      .catch((error) => {
        setToastConfig({
          ...toastConfig,
          type: "error",
          message: "Error al cargar plantillas",
          isVisible: true,
        });
      });
  };

  // Función para cerrar el modal
  const cerrarModalPlantillas = () => {
    setShowModalPlantillas(false);
    setPlantillaSeleccionada(null);
    setUsuarioParaAsignar(null);
  };

  // Función para asignar la plantilla seleccionada al usuario
  const asignarPlantillaAUsuario = () => {
    if (!plantillaSeleccionada || !usuarioParaAsignar) {
      console.warn("Faltan datos para asignar la plantilla");
      return;
    }
    if (establecimientosSeleccionados.length === 0) {
      setToastConfig({
        ...toastConfig,
        type: "error",
        message: "Debes seleccionar al menos un establecimiento",
        isVisible: true,
      });
      return;
    } else {
      const userData = JSON.parse(localStorage.getItem("userData"));
      establecimientosSeleccionados.forEach(establecimiento => {
        establecimiento.modificadoPor = userData.id || userData.uid;
        establecimiento.modificadoFecha = new Date();
        establecimiento.modificadoPorNombre = userData.nombre || userData.name;
        establecimiento.desde = "Asignar Plantilla";
      });
    }



    // Obtener el orden_ruta de la plantilla seleccionada
    const plantillaEncontrada = plantillasFiltradas.find(
      (p) => p.id === plantillaSeleccionada
    );
    const ordenRuta = plantillaEncontrada?.orden_ruta || "";
    DinamicQueries.getDataWithParameters(
      "asignarPlantillaUsuario",
      "rutasPlanilla/",
      {
        plantillaId: plantillaSeleccionada,
        usuarioId: usuarioParaAsignar.uid,
        establecimientos: establecimientosSeleccionados,
        orden_ruta: ordenRuta,
      }
    )
      .then((res) => {
        console.log("Respuesta del backend:", res);

        if (res.data?.success) {
          setToastConfig({
            ...toastConfig,
            type: "success",
            message: res.data.message || "Plantilla asignada correctamente",
            isVisible: true,
          });
          cerrarModalPlantillas();
          // Actualizar la lista de usuarios para reflejar el cambio en orden_ruta
          getAllUser();
        } else {
          setToastConfig({
            ...toastConfig,
            type: "error",
            message:
              res.data?.message || "Ocurrió un error al asignar la plantilla",
            isVisible: true,
          });
        }
      })
      .catch((error) => {
        console.error("Error en la llamada a asignarPlantillaUsuario:", error);
        setToastConfig({
          ...toastConfig,
          type: "error",
          message: "Error de red o del servidor",
          isVisible: true,
        });
      });
  };

  const searchEstablecimientos = (e) => {
    if (e.value != "") {
      setAsignacion({ ...Asignacion, region: e.value });
      console.log(e.value);
      DinamicQueries.getDataWithParameters("callProcedure", "analytics/", {
        method: "sp_get_storeWithRegion",
        params: {
          nameRegion: e.value,
        },
      }).then((establecimientos) => {
        console.log(establecimientos);
        setEstablecimientos(establecimientos.data);
      });
    }
  };

  const handleOptionChange = (e) => {
    if (e.fullName === "selectedRowKeys") {
      setidsEstablecimientoToAssing(e.value);
    }
  };

  const openDeletePopup = (uid) => {
    setShowPopupDelete(true);
    setSelectedIdEstablecimiento(uid);
  };

  const hideDeletePopup = () => {
    setShowPopupDelete(false);
  };

  const cellRenderAsignar = (data) => {
    return (
      <div className="d-flex icons_grid">
        {/* <i className="dx-icon-edit" onClick={()=>editClient(data.data)}></i> */}
        <i
          className="dx-icon-trash"
          onClick={() => openDeletePopup(data.data.ID)}
        ></i>
      </div>
    );
  };

  const checkedLabel = { "aria-label": "Checked" };

  const cellRendeRuta = (data) => {
    return (
      <div
        className="d-flex icons_grid"
        style={{ justifyContent: "center", display: "flex" }}
      >
        {/* <i className="dx-icon-edit" onClick={()=>editClient(data.data)}></i> */}
        {/* <i
          className="dx-icon-trash"
          onClick={() => openDeletePopup(data.data.id_establecimiento)}
        ></i> */}
        <CheckBox
          defaultValue={data.value}
          elementAttr={checkedLabel}
          onValueChanged={(e) => changeDays(e, data)}
        />
      </div>
    );
  };

  const changeDays = (e, data) => {
    let dataFinal = [...Asignacion.establecimientosFinal];

    let infoFinal = [];
    // console.log(dataFinal)
    // console.log(data.data.key)
    dataFinal.forEach((x) => {
      if (x.key == data.data.key) {
        switch (data.columnIndex) {
          case 3:
            x.lunes = e.value;
            break;
          case 4:
            x.martes = e.value;
            break;
          case 5:
            x.miercoles = e.value;
            break;
          case 6:
            x.jueves = e.value;
            break;
          case 7:
            x.viernes = e.value;
            break;
          case 8:
            x.sabado = e.value;
            break;
          case 9:
            x.domingo = e.value;
            break;
          default:
            break;
        }
      }
      infoFinal.push(x);
    });

    setAsignacion({
      ...Asignacion,
      establecimientos: infoFinal,
      establecimientosFinal: infoFinal,
    });
  };

  const deleteEstablecimientos = () => {
    DinamicQueries.getDataWithParameters(
      "DeleteAsignacionEstablecimientos",
      "usuarios/",
      { uid: UserSelected, idEstablecimiento: SelectedIdEstablecimiento }
    )
      .then((data) => {
        if (data.status === 200) {
          setAsignacion(initialState);
          hideDeletePopup();
          AsignarData(DataUsuarioSelected);
          getAllUser();

          setToastConfig({
            ...toastConfig,
            type: "success",
            message: "¡Guardado Exitosamente!",
            isVisible: true,
          });
        } else {
        }
      })
      .catch((err) => {
        setToastConfig({
          ...toastConfig,
          type: "error",
          message: err.message,
          isVisible: true,
        });
        setAsignacion(initialState);
        hidePopup();
        hideDeletePopup();
      });
  };

  const onHiding = () => {
    setToastConfig({
      ...toastConfig,
      isVisible: false,
    });
  };

  const asignarRuta = () => {
    setdisabledRuta(true);

    let dataFinal = [...Asignacion.establecimientosFinal].slice();

    let infoFinal = [];

    dataFinal.forEach((x) => {
      x.dias = [];

      if (x.lunes) {
        x.dias.push(1);
      }
      if (x.martes) {
        x.dias.push(2);
      }
      if (x.miercoles) {
        x.dias.push(3);
      }
      if (x.jueves) {
        x.dias.push(4);
      }
      if (x.viernes) {
        x.dias.push(5);
      }
      if (x.sabado) {
        x.dias.push(6);
      }
      if (x.domingo) {
        x.dias.push(7);
      }
      delete x.lunes;
      delete x.martes;
      delete x.miercoles;
      delete x.jueves;
      delete x.viernes;
      delete x.sabado;
      delete x.domingo;
      infoFinal.push(x);
    });

    console.log(infoFinal);
    const _rutaUserData = JSON.parse(localStorage.getItem("userData")) || {};
    DinamicQueries.getDataWithParameters(
      "AsignarNewCollectionEstablecimientos",
      "usuarios/",
      {
        uid: UserSelected,
        establecimientos: infoFinal,
        ModificadoPor: {
          id: _rutaUserData.id || "",
          key: _rutaUserData.key || "",
          uid: _rutaUserData.uid || "",
          nombre: `${_rutaUserData.nombre || ""} ${_rutaUserData.apellido || ""}`.trim(),
          cedula: _rutaUserData.cedula || "",
        },
      }
    )
      .then((data) => {
        if (data.status === 200) {
          setToastConfig({
            ...toastConfig,
            type: "success",
            message: "¡Ruta cargada exitosamente!",
            isVisible: true,
          });
          let newData = [];
          infoFinal.forEach((x) => {
            x.lunes = false;
            x.martes = false;
            x.miercoles = false;
            x.jueves = false;
            x.viernes = false;
            x.sabado = false;
            x.domingo = false;
            if (x.dias != undefined) {
              x.dias.forEach((dia) => {
                switch (dia) {
                  case 1:
                    x.lunes = true;
                    break;
                  case 2:
                    x.martes = true;
                    break;
                  case 3:
                    x.miercoles = true;
                    break;
                  case 4:
                    x.jueves = true;
                    break;
                  case 5:
                    x.viernes = true;
                    break;
                  case 6:
                    x.sabado = true;
                    break;
                  case 7:
                    x.domingo = true;
                    break;
                  default:
                    break;
                }
              });
            }
            newData.push(x);
          });
          setAsignacion({
            ...Asignacion,
            establecimientos: newData,
            establecimientosFinal: newData,
          });

          setTimeout(() => {
            setdisabledRuta(false);
          }, 1000);
        }
      })
      .catch((err) => { });
  };

  const saveButtonOptions = {
    icon: "check",
    text: "Guardar Ruta",
    onClick: asignarRuta,
    disabled: disabledRuta,
  };

  const handleOptionChangeAsigando = (e) => {
    if (e.fullName === "selectedRowKeys") {
      setidsEstablecimientoAsiganed(e.value);
    }
  };

  const eliminarRegistros = (arrayObjetos, arrayStrings) => {
    return arrayObjetos.filter((objeto) => !arrayStrings.includes(objeto.ID));
  };

  const deleteEstablecimientosMultiples = () => {
    // console.log(idsEstablecimientoAsiganed)

    DinamicQueries.getDataWithParameters(
      "DeleteMultipleAsignacionEstablecimientos",
      "usuarios/",
      { uid: UserSelected, idEstablecimientos: idsEstablecimientoAsiganed }
    )
      .then((data) => {
        if (data.status === 200) {
          setAsignacion(initialState);
          hideDeletePopup();
          AsignarData(DataUsuarioSelected);
          getAllUser();

          setToastConfig({
            ...toastConfig,
            type: "success",
            message: "¡Guardado Exitosamente!",
            isVisible: true,
          });
        } else {
        }
      })
      .catch((err) => {
        setToastConfig({
          ...toastConfig,
          type: "error",
          message: err.message,
          isVisible: true,
        });
        setAsignacion(initialState);
        hidePopup();
        hideDeletePopup();
      });
  };

  const getSelected = ({ selectedRowsData }) => {
    if (selectedRowsData.length > 0) {
      setWeekButtons(true);
      setSelectedStablisments(selectedRowsData);
    } else {
      setWeekButtons(false);
      setSelectedStablisments([]);
    }
  };

  const setToDay = (day) => {
    selectedStablisments.forEach((cadaEstablecimiento) => {
      const e = {
        value: true,
      };

      const data = {
        data: {
          key: cadaEstablecimiento.key,
        },
        columnIndex: day,
      };

      changeDays(e, data);
    });
  };

  const handlePlantillaSeleccionada = (e) => {
    setPlantillaSeleccionada(e.value);
    if (e.value) {
      DinamicQueries.getDataWithParameters(
        "getEstablecimientosByPlantilla",
        "rutasPlanilla/",
        { plantillaId: e.value }
      )
        .then((res) => {
          const establecimientosRaw = res.data.data || [];

          const diasMap = {
            1: "lunes",
            2: "martes",
            3: "miercoles",
            4: "jueves",
            5: "viernes",
            6: "sabado",
            7: "domingo",
          };

          const transformados = establecimientosRaw.map((est) => {
            const nuevo = { ...est };

            // Marcar días como true
            if (Array.isArray(est.dias)) {
              est.dias.forEach((n) => {
                const dia = diasMap[n];
                if (dia) nuevo[dia] = true;
              });
            }

            // Asegurar que todos los días estén presentes
            Object.values(diasMap).forEach((dia) => {
              if (!(dia in nuevo)) nuevo[dia] = false;
            });

            return nuevo;
          });

          setEstablecimientosPlantilla(transformados);
        })
        .catch(() => setEstablecimientosPlantilla([]));
    } else {
      setEstablecimientosPlantilla([]);
    }
  };

  const handleMap = async () => {
    if (usuariosSeleccionados.length === 0) {
      setToastConfig({
        ...toastConfig,
        type: "warning",
        message:
          "Para ver los establecimientos en el mapa antes debe seleccionar un usuario",
        isVisible: true,
      });
      return;
    }

    try {
      // Mostrar mensaje de carga
      setToastConfig({
        ...toastConfig,
        type: "info",
        message: "Cargando datos de rutas...",
        isVisible: true,
      });

      const promesasRutas = usuariosSeleccionados.map((usuario) =>
        obtenerDatosRutaUsuario(usuario)
      );

      const resultados = await Promise.all(promesasRutas);

      const rutasValidas = resultados.filter((resultado) => resultado !== null);

      console.log("Datos de rutas obtenidos:", rutasValidas);

      if (rutasValidas.length === 0) {
        setToastConfig({
          ...toastConfig,
          type: "warning",
          message: "No se encontraron rutas con establecimientos válidos",
          isVisible: true,
        });
        return;
      }

      // Guardar las rutas y abrir el popup del mapa
      setRutasParaMapa(rutasValidas);
      setShowPopupMapa(true);

      setToastConfig({
        ...toastConfig,
        type: "success",
        message: `${rutasValidas.length} ruta(s) cargada(s) exitosamente`,
        isVisible: true,
      });
    } catch (error) {
      console.error("Error al obtener rutas:", error);
      setToastConfig({
        ...toastConfig,
        type: "error",
        message: "Error al obtener datos de rutas",
        isVisible: true,
      });
    }
  };

  const handleSelectionUsuarios = (e) => {
    setUsuariosSeleccionados(e.selectedRowsData);
  };

  const handleRowUpdated = (e) => {
    const updatedData = e.data; // <-- AQUÍ viene la info final de la fila

    console.log("Datos actualizados:", updatedData);

    // Guardar el estado anterior por si hay error
    const previousUsers = [...User];

    // Convertir orden_ruta a string si es número, pero si es 0 enviar ""
    const ordenRutaString =
      updatedData.orden_ruta != null && updatedData.orden_ruta !== 0
        ? String(updatedData.orden_ruta)
        : "";

    // Actualizar el estado local con el valor como string
    const updatedDataWithString = {
      ...updatedData,
      orden_ruta: ordenRutaString,
    };

    const updatedUsers = User.map((user) =>
      user.uid === updatedData.uid ? updatedDataWithString : user
    );
    setUser(updatedUsers);

    // Enviar a la API (siempre como string)
    DinamicQueries.getDataWithParameters("updateOrdenRuta", "usuarios/", {
      uid: updatedData.uid,
      orden_ruta: ordenRutaString,
    })
      .then((response) => {
        if (response.status === 200 && response.data?.msg) {
          setToastConfig({
            ...toastConfig,
            type: "success",
            message:
              response.data.text || "Orden de ruta actualizado correctamente",
            isVisible: true,
          });
        } else {
          throw new Error("Error en la respuesta del servidor");
        }
      })
      .catch((err) => {
        console.error("Error al actualizar:", err);

        // Revertir cambios
        setUser(previousUsers);

        setToastConfig({
          ...toastConfig,
          type: "error",
          message:
            err.response?.data?.text ||
            err.message ||
            "Error al actualizar el orden de ruta",
          isVisible: true,
        });
      });
  };

  const cerrarPopupMapa = () => {
    setShowPopupMapa(false);
    setRutasParaMapa([]);
  };

  // Filtra las plantillas por la(s) región(es) del usuario seleccionado
  const regionesUsuario = usuarioParaAsignar?.region || [];
  const plantillasFiltradas = plantillasRutas.filter((plantilla) =>
    regionesUsuario.includes(plantilla.region)
  );

  return (
    <React.Fragment>
      <div className="d-flex mt-4 mb-4">
        <div className="header-grid-title">
          <h5 className="content-block titleCliente">Rutas</h5>
        </div>
      </div>

      <div className="tabla-Cliente">
        <DataGrid
          className="tabla-Cliente"
          dataSource={User}
          showBorders={true}
          remoteOperations={true}
          focusedRowEnabled={true}
          defaultFocusedRowIndex={0}
          style={{ height: "400px", width: "100%" }}
          keyExpr="uid"
          onSelectionChanged={handleSelectionUsuarios}
          onRowUpdated={handleRowUpdated}
        >
          <Editing
            mode="row"
            allowUpdating={true}
            allowAdding={false}
            allowDeleting={false}
          />
          <Export enabled={true} />
          <ColumnChooser enabled={true} mode="select" />
          <FilterRow visible={true} />
          <Paging defaultPageSize={12} />
          <Selection mode="multiple" />
          <Pager
            showPageSizeSelector={true}
            allowedPageSizes={allowedPageSizes}
          />
          <HeaderFilter visible={true} />
          <Toolbar>
            <Item location="after">
              <Button
                icon="fas fa-map-marker-alt"
                onClick={handleMap}
                style={{ color: "green" }}
              />
            </Item>
            <Item name="exportButton" />
            <Item name="columnChooserButton" />
          </Toolbar>
          {/* 
            <Column
              width={180}
              caption="Cod Cliente"
              dataField="cod_cliente"
              dataType="string"
            /> */}
          <Column
            // width={180}
            caption="Cédula"
            dataField="cedula"
            dataType="string"
            allowEditing={false}
          />
          <Column
            // width={150}
            caption="Nombre"
            dataField="nombre"
            dataType="string"
            allowEditing={false}
          />

          <Column
            // width={180}
            caption="Region"
            dataField="region"
            dataType="string"
            allowEditing={false}
          />

          <Column
            // width={180}
            caption="Clientes"
            dataField="cliente"
            dataType="string"
            allowEditing={false}
          />
          <Column
            // width={180}
            caption="Orden Ruta"
            dataField="orden_ruta"
            dataType="number"
            allowEditing={true}
            editorOptions={{
              format: {
                type: "fixedPoint",
                precision: 0,
              },
            }}
            setCellValue={(rowData, value) => {
              // Convertir a número si viene como string, o mantener null/undefined
              rowData.orden_ruta =
                value != null && value !== "" ? Number(value) : null;
            }}
          />

          <Column
            // width={80}
            caption=""
            allowSorting={false}
            cellRender={cellRender}
          />
        </DataGrid>
      </div>

      <Popup
        visible={showPopup}
        onHiding={hidePopup}
        showTitle={true}
        title={msgPopup}
        showCloseButton={true}
        fullScreen={true}
      >
        <ScrollView width={"100%"} height={"100%"}>
          {/* <ToolbarItem
          widget="dxButton"
          toolbar="top"
          location="after"
          options={saveButtonOptions}
        /> */}

          <div className="row">
            {/* <div className="col-md-6">
              <SelectBox
                className="SelectBoxC mb-2 mt-3"
                placeholder="Seleccione un cliente"
                label="Cliente"
                dataSource={Clientes}
                onValueChanged={(e) => searchCliente(e)}
                defaultValue={Asignacion.cliente}
                value={Asignacion.cliente}
                searchEnabled={true}
              />
            </div> */}
            <div className="col-md-12">
              <SelectBox
                className="SelectBoxR mb-2"
                placeholder="Seleccione una región"
                label="Región"
                dataSource={Regiones}
                onValueChanged={(e) => searchEstablecimientos(e)}
                defaultValue={Asignacion.region}
                value={Asignacion.region}
                searchEnabled={true}
              />
            </div>
          </div>

          <div
            className="row mx-5"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div className="col-md-5 mt-2">
              <div
                className={"dx-card"}
                style={{ padding: "20px", borderRadius: "15px" }}
              >
                <h6 className="title">Establecimientos</h6>
                <DataGrid
                  className="tabla-user"
                  dataSource={Establecimientos}
                  showBorders={true}
                  remoteOperations={true}
                  // focusedRowEnabled={true}
                  defaultFocusedRowIndex={0}
                  style={{ height: "60vh", width: "100%" }}
                  keyExpr="ID_FB"
                  // selectedRowKeys={this.state.selectedRowKeys}
                  onOptionChanged={(e) => handleOptionChange(e)}
                  wordWrapEnabled={true}
                >
                  <FilterRow visible={true} />
                  <Selection mode="multiple" />
                  <LoadPanel enabled />
                  <Paging defaultPageSize={12} />
                  <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                  />
                  <HeaderFilter visible={true} />

                  <Column caption={"ID"} dataField={"ID_STORE"} width={100} />
                  {/* <Column caption={"Id Origen"} dataField={"id_origen"} width={120} /> */}
                  <Column
                    dataField={"NAME"}
                    caption={"Nombre Establecimiento"}
                    dataType="string"
                  />
                  {/* <Column
                dataField={"direccion"}
                caption={"Direccion"}
                dataType="string"
                width={120}
              /> */}
                  {/* <Column
                dataField={"descripcion_razon_social"}
                caption={"Razon Social"}
                dataType="string"
              /> */}
                  {/* <Column dataField={"canal"} caption={"Canal"} dataType="string" />
              <Column dataField={"subcanal"} caption={"Subcanal"} dataType="string" />
              <Column dataField={"ciudad"} caption={"ciudad"} dataType="string" />
              <Column dataField={"region"} caption={"Region"} dataType="string" />
              <Column dataField={"zona"} caption={"Zona"} dataType="string" /> */}
                  {/* <Column
                dataField={"descripcion_agrupador"}
                caption={"Agrupador"}
                dataType="string"
              /> */}
                  {/* <Column dataField={"estatus"} caption={"Estatus"} dataType="string" /> */}
                  {/* <Column
                dataField={"nombre_cliente"}
                caption={"Cliente"}
                dataType="string"
              /> */}
                </DataGrid>
              </div>
            </div>
            <div
              className="col-md-1 mt-6"
              style={{
                display: "grid",
                alignContent: "center",
                justifyContent: "center",
              }}
            >
              <Button
                className="btn btn-light mt-4"
                onClick={() => saveEstablishment()}
                style={{ width: "10vw" }}
              >
                Asignar <ArrowRight style={{ marginLeft: "5px" }} />
              </Button>
              <Button
                className="btn btn-light mt-4"
                onClick={(e) => deleteEstablecimientosMultiples()}
              >
                Eliminar <ArrowLeft style={{ marginLeft: "5px" }} />
              </Button>
              {/* onClick={() => saveUser()} */}
            </div>
            <div className="col-md-5 mt-2">
              <div
                className={"dx-card"}
                style={{ padding: "20px", borderRadius: "15px" }}
              >
                <h6 className="title">
                  Establecimientos asignados a {UserSelectedData}
                </h6>
                {/* {AssingTo} */}
                <DataGrid
                  className="tabla-user"
                  dataSource={Asignacion.establecimientosFinal}
                  showBorders={true}
                  remoteOperations={true}
                  // focusedRowEnabled={true}
                  defaultFocusedRowIndex={0}
                  style={{ height: "60vh", width: "100%" }}
                  keyExpr="ID"
                  wordWrapEnabled={true}
                  onOptionChanged={(e) => handleOptionChangeAsigando(e)}
                >
                  <FilterRow visible={true} />
                  <Selection mode="multiple" />
                  <LoadPanel enabled />
                  <Paging defaultPageSize={12} />
                  <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                  />
                  <HeaderFilter visible={true} />

                  <Column
                    caption="ID"
                    dataField="ID"
                    dataType="string"
                    width={100}
                  />
                  <Column
                    caption="Nombre"
                    dataField="nombre_establecimiento"
                    dataType="string"
                  />

                  <Column
                    caption=""
                    allowSorting={false}
                    cellRender={cellRenderAsignar}
                  />
                </DataGrid>
              </div>
            </div>
          </div>

          {/* <ScrollView width="100%" height="100%">
          <div className="">
            <div className="">
              
            </div>

            <div className="">
              
            </div>

            <div className="">
              
              <TagBox
              className="inputEstablecimiento" 
                showSelectionControls={true}
                items={Establecimientos}
                placeholder="Establecimientos"
                valueExpr="nombre_establecimiento"
                displayExpr="nombre_establecimiento"
                onValueChanged={(e) => setAsignacion({...Asignacion, establecimientos:e.value, establecimientosFinal:e.value})}
                value={Asignacion.establecimientos}
                defaultValue ={Asignacion.establecimientos}
                searchEnabled={true}
              />
            </div>

          <div className="mt-4">
            <div className="nombreListaEstablecimiento">Establecimientos asignados</div>
            <div className="">
                <List
                  className="ListaEstablecimiento"
                  dataSource={Asignacion.establecimientosFinal}
                  height={300}
                  itemRender={SelectInitialPage}
                
                  />
              </div>
            </div>           
          </div>
        </ScrollView> */}
        </ScrollView>
      </Popup>

      <Popup
        width={"auto"}
        height={"auto"}
        visible={showPopupDelete}
        onHiding={hideDeletePopup}
        showTitle={true}
        title="Eliminar Asignacion"
        showCloseButton={true}
      >
        <ScrollView width="100%" height="100%">
          <div className="form-container text-center">
            <ExclamationDiamond className="warning_icon" />
            <h5>¿Seguro que desea eliminar esta asignación?</h5>
            <p>Esta acción no puede revertirse</p>
            <div className="d-flex text-center col-md-12 button_popup">
              <Button
                onClick={deleteEstablecimientos}
                className="btn btn-outline-primary"
              >
                Sí, eliminar
              </Button>
              <Button
                onClick={hideDeletePopup}
                className="btn btn-outline-secondary"
              >
                Cancelar
              </Button>
            </div>
          </div>
        </ScrollView>
      </Popup>

      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        onHiding={onHiding}
        displayTime={toastConfig.displayTime}
      />

      {/* Show grid de ruta */}

      <Popup
        visible={showPopupRuta}
        onHiding={hidePopupRuta}
        showTitle={true}
        title="Asignar Ruta"
        showCloseButton={true}
        fullScreen={true}
      >
        <ToolbarItem
          widget="dxButton"
          toolbar="top"
          location="after"
          options={saveButtonOptions}
        />
        {/* <ScrollView width={"100%"} height={"100%"}> */}
        <div className="row" style={{ height: "100%" }}>
          <div className="col-md-12 mt-2" style={{ height: "100%" }}>
            {weekButtons && (
              <>
                <div className="mb-3">
                  Asignar todos los establecimientos seleccionados para el dia:
                </div>
                <div className="mb-4">
                  <Button
                    onClick={() => {
                      setToDay(3);
                    }}
                    className="btn-agregar"
                    style={{ width: "150px", marginRight: "10px" }}
                  >
                    Lunes
                  </Button>
                  <Button
                    onClick={() => {
                      setToDay(4);
                    }}
                    className="btn-agregar"
                    style={{ width: "150px", marginRight: "10px" }}
                  >
                    Martes
                  </Button>
                  <Button
                    onClick={() => {
                      setToDay(5);
                    }}
                    className="btn-agregar"
                    style={{ width: "150px", marginRight: "10px" }}
                  >
                    Miércoles
                  </Button>
                  <Button
                    onClick={() => {
                      setToDay(6);
                    }}
                    className="btn-agregar"
                    style={{ width: "150px", marginRight: "10px" }}
                  >
                    Jueves
                  </Button>
                  <Button
                    onClick={() => {
                      setToDay(7);
                    }}
                    className="btn-agregar"
                    style={{ width: "150px", marginRight: "10px" }}
                  >
                    Viernes
                  </Button>
                  <Button
                    onClick={() => {
                      setToDay(8);
                    }}
                    className="btn-agregar"
                    style={{ width: "150px", marginRight: "10px" }}
                  >
                    Sábado
                  </Button>
                  <Button
                    onClick={() => {
                      setToDay(9);
                    }}
                    className="btn-agregar"
                    style={{ width: "150px" }}
                  >
                    Domingo
                  </Button>
                </div>
              </>
            )}
            {/* {AssingTo} */}
            <DataGrid
              className="tabla-user"
              dataSource={Asignacion.establecimientosFinal}
              showBorders={true}
              remoteOperations={true}
              // focusedRowEnabled={true}
              defaultFocusedRowIndex={0}
              style={{ height: "85vh", width: "100%" }}
              // ref={(ref) => { setDataGrid(ref.instance.clear) }}
              onSelectionChanged={getSelected}
              keyExpr="ID"
              wordWrapEnabled={true}
              paginate={false}
              paging={false}
              columnAutoWidth={true}
            >
              {/* <Export enabled={true} />
            <ColumnChooser
                enabled={true}
                mode="select" 
            /> */}
              <Selection
                showCheckBoxesMode={"always"}
                selectAllMode={"allPages"}
                mode={"multiple"}
              />
              <FilterRow visible={true} />
              <LoadPanel enabled />
              <Scrolling
                useNative={false}
                scrollByContent={true}
                scrollByThumb={true}
                showScrollbar="onHover"
              />

              {/* <Paging defaultPageSize={12} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={allowedPageSizes}
            /> */}
              <HeaderFilter visible={true} />

              <Column
                caption="ID establecimiento"
                dataField="ID"
                dataType="string"
                width={220}
              />
              <Column
                caption="Nombre"
                dataField="nombre_establecimiento"
                dataType="string"
                width={290}
              />

              <Column
                caption="Lunes"
                dataField="lunes"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />

              <Column
                caption="Martes"
                dataField="martes"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />

              <Column
                caption="Miercoles"
                dataField="miercoles"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />

              <Column
                caption="Jueves"
                dataField="jueves"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />

              <Column
                caption="Viernes"
                dataField="viernes"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />

              <Column
                caption="Sabado"
                dataField="sabado"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />

              <Column
                caption="Domingo"
                dataField="domingo"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />
            </DataGrid>
          </div>
        </div>
        {/* </ScrollView> */}
      </Popup>

      <Popup
        visible={showModalPlantillas}
        onHiding={cerrarModalPlantillas}
        showTitle={true}
        title="Asignar plantilla de ruta"
        showCloseButton={true}
        fullScreen={true}
      >
        <div className="form-group d-flex align-items-end" style={{ gap: 16 }}>
          <div>
            <label>Selecciona una plantilla de ruta</label>
            <SelectBox
              dataSource={plantillasFiltradas}
              valueExpr="id"
              displayExpr="nombre_plantilla"
              value={plantillaSeleccionada}
              onValueChanged={handlePlantillaSeleccionada}
              searchEnabled={true}
              placeholder="Selecciona una plantilla"
              width={300}
              height={38}
            />
          </div>
          <div>
            <label>Orden de ruta</label>
            <div
              style={{
                padding: "8px 12px",
                border: "1px solid #ddd",
                borderRadius: "4px",
                minHeight: "32px",
                width: "100px",
                display: "flex",
                alignItems: "center",
                backgroundColor: "#f5f5f5",
              }}
            >
              {plantillaSeleccionada
                ? plantillasFiltradas.find(
                  (p) => p.id === plantillaSeleccionada
                )?.orden_ruta || "-"
                : "-"}
            </div>
          </div>
          <div
            className="d-flex"
            style={{ gap: 8, marginBottom: 0, alignItems: "flex-end" }}
          >
            <Button
              className="btn btn-primary"
              onClick={asignarPlantillaAUsuario}
              disabled={!plantillaSeleccionada}
            >
              Asignar
            </Button>
            <Button
              className="btn btn-secondary ml-2"
              onClick={cerrarModalPlantillas}
            >
              Cancelar
            </Button>
          </div>
        </div>
        {establecimientosPlantilla.length > 0 && (
          <div className="mt-3">
            <label>Establecimientos de la plantilla:</label>
            <DataGrid
              dataSource={establecimientosPlantilla}
              showBorders={true}
              style={{ height: "400px", width: "100%" }}
              keyExpr="ID"
              onSelectionChanged={(e) =>
                setEstablecimientosSeleccionados(e.selectedRowsData)
              }
            >
              <FilterRow visible={true} />
              <Selection mode="multiple" />
              <Column
                caption="ID"
                dataField="ID"
                dataType="string"
                width={100}
              />
              <Column
                caption="Nombre"
                dataField="nombre_establecimiento"
                dataType="string"
              />
              <Column
                caption="Región"
                dataField="nombre_region"
                dataType="string"
              />
              <Column
                caption="Lunes"
                dataField="lunes"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />
              <Column
                caption="Martes"
                dataField="martes"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />
              <Column
                caption="Miercoles"
                dataField="miercoles"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />
              <Column
                caption="Jueves"
                dataField="jueves"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />
              <Column
                caption="Viernes"
                dataField="viernes"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />
              <Column
                caption="Sabado"
                dataField="sabado"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />
              <Column
                caption="Domingo"
                dataField="domingo"
                allowSorting={false}
                alignment="center"
                cellRender={cellRendeRuta}
                allowFiltering={false}
              />
            </DataGrid>
          </div>
        )}
      </Popup>

      {/* Popup del Mapa de Rutas */}
      <Popup
        visible={showPopupMapa}
        onHiding={cerrarPopupMapa}
        showTitle={true}
        title="Mapa de Rutas"
        showCloseButton={true}
        fullScreen={true}
      >
        <div style={{ height: "100%", width: "100%", marginTop: "20px" }}>
          {rutasParaMapa.length > 0 && (
            <MapRoutes rutasUsuarios={rutasParaMapa} />
          )}
        </div>
      </Popup>
    </React.Fragment>
  );
}

export default AssignmentNew;
